document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver(() => {
    const thankyouModal = document.querySelector(".b2b-nt-thankyou-modal");
    if (thankyouModal && !thankyouModal.querySelector(".back-to-main-store-btn")) {
      // create btn Back To Store
      const btn = document.createElement("a");
      btn.href = "https://freshfood2u.co/";
      btn.className = "back-to-main-store-btn";
      btn.style.padding = "10px 20px";
      btn.style.backgroundColor = "#1773B0";
      btn.style.border = "2px solid #1773B0";
      btn.style.borderRadius = "4px"
      btn.style.color = "#fff";
      btn.style.fontSize = "14px";
      btn.style.fontWeight = "400";
      btn.style.textAlign = "center";
      btn.innerText = "Back to store";

      // Hover giống hệ thống
      btn.addEventListener("mouseenter", () => {
        btn.style.backgroundColor = "white";
        btn.style.color = "#1773B0";
        btn.style.border = "2px solid #1773B0";
      });

      btn.addEventListener("mouseleave", () => {
        btn.style.backgroundColor = "#1773B0";
        btn.style.color = "#fff";
        btn.style.border = "2px solid #1773B0";
      });

      // after `.b2b-nt-modal-content`
      const modalContent = thankyouModal.querySelector(".b2b-nt-modal-content");
      if (modalContent) {
        modalContent.insertAdjacentElement("afterend", btn);
      }         
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener("BSS:CustomOrderNote", async(e) => {
  const { deliveryDateFromSession } = e.detail;
  console.log(deliveryDateFromSession)
    let currentNote = await getCartNote()
    currentNote = `Customer Note: ${deliveryDateFromSession}`;

    await updateCartNote(currentNote);
});

async function getCartNote() {
  try {
    const response = await fetch("/cart/update.js", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data.note;
  } catch (error) {
    console.error("Error fetching cart note:", error);
    return null;
  }
}

async function updateCartNote(note) {
  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ note }),
  })
    .then((response) => response.json())
    .then((data) => console.log("Cart note updated:", data.note))
    .catch((error) => console.error("Error updating cart note:", error));
}

window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};
window.BSS_B2B = window.BSS_B2B || {};
window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};

window.BSS_B2B.addAction("custom:cart/showPrice", syncFinalPriceToCustom);

// if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
//   setTimeout(() => {
//     const observer = new MutationObserver((MutationList) => {
//       for (let item of MutationList) {
//         if (
//           item.target.classList.contains("cart__summary") ||
//           item.target.classList.contains("cart-drawer__summary")
//         ) {
//           addStylePriceGroup();
//           setTimeout(() => {
//             syncFinalPriceToCustom();
//           }, 500);
//         }
//       }
//     });
//     observer.observe(document.body, {
//       childList: true,
//       subtree: true,
//     });
//   }, 300);

//   setTimeout(() => {
//     syncFinalPriceToCustom();
//   }, 1500);
// }

const isCart = window.location.pathname === '/cart';
if(isCart) {
    setTimeout(() => {
      syncFinalPriceToCustom();
    }, 1000);
}

document.addEventListener("BSS:openCartSlider", e => {
  addStylePriceGroup();
  for(let i=0; i<12; ++i) {
    setTimeout(() => {
      syncFinalPriceToCustom();
    }, 500 * i);
  }
})

document.addEventListener("BSS:cart-drawer/change-qty", e => {
  syncFinalPriceToCustom();
})

function syncFinalPriceToCustom() {
  let checkOrder = true;
  const itemElements = document.querySelectorAll(".supplier_group");
  itemElements.forEach((itemEl) => {
    const priceSpans = itemEl.querySelectorAll(
      "[bss-b2b-final-line-price] span[style], [bss-b2b-final-line-price]:not(:has(span[style])), .cart-item__total .price__current:not(:has(span[style]))"
    );
    const customEl = itemEl.querySelector(`[bss-b2b-cart-custom]`);
    let subtotalGroup = 0;
    priceSpans.forEach(priceSpan => {
      if (priceSpan && customEl) {
        subtotalGroup += parseMoneyStringToCents(priceSpan.textContent);
      }
    })
    customEl.textContent = BSS_B2B.formatMoney(subtotalGroup);
      // Tính toán thress hold và xử lý ẩn/hiện banner
      const dataThresholdPrice = itemEl.querySelector("[data-threshold-price]")?.getAttribute("data-threshold-price") || 0;
      const bannerGreen = itemEl.querySelector(".supplier_checkout_threshould.value_match");
      const bannerRed = itemEl.querySelector(".supplier_checkout_threshould.not_match");
      const linkCollectionWithBannerRed = itemEl.querySelector(".shop_supplier");
      const checkoutOK = document.querySelector(".confirm-order");
      const checkoutNotOK = document.querySelector(".not-yet");
      const text_label = itemEl.querySelector("[text-label]")?.getAttribute('text-label');
      if(subtotalGroup >= dataThresholdPrice) {
        if(bannerGreen) {
          bannerGreen.style.display = "inline-flex";
        }
        if(bannerRed && bannerGreen) {
          bannerRed.style.display = "none";
        }
        if(linkCollectionWithBannerRed) {
          linkCollectionWithBannerRed.style.display = "none";
        }
      } else {
        checkOrder = false;
        if(checkoutNotOK) {
          checkoutNotOK.style.display = "inline-block";
        }
        if(bannerRed && bannerGreen) {
          bannerGreen.style.display = "none";
        }
        if(bannerRed) {
          bannerRed.style.display = "inline-flex";
          // bannerRed.innerHTML = `Spend ${BSS_B2B.formatMoney(dataThresholdPrice - subtotalGroup)} in ${text_label} to checkout`;
          bannerRed.innerHTML = `${text_label.replace("£0.00", BSS_B2B.formatMoney(dataThresholdPrice - subtotalGroup))}`;
        }
        if(linkCollectionWithBannerRed) {
          linkCollectionWithBannerRed.style.display = "inline-flex";
        }
      }

      if(checkOrder) {
        if(checkoutOK)
          checkoutOK.style.display = "inline-block";
        if(checkoutNotOK)
          checkoutNotOK.style.display = "none";
      } else {
        checkOrder = false;
        if(checkoutOK)
          checkoutOK.style.display = "none";
      }
  });
}

function parseMoneyStringToCents(moneyString) {
    if (typeof moneyString !== 'string') return 0;

    let raw = moneyString
        .replace(/<\/?[^>]+(>|$)/g, '')
        .replace(/[\s\xa0]/g, '')

        .replace(/(HT|A\$|\$|£|€|¥|₫|₩|đ|USD|AUD|CAD|GBP|NT|CHF|₴|zł|kr|R\$)/gi, '')
        .replace(/,/g, '.');

    const parts = raw.split('.');
    let number;

    if (parts.length > 2) {
        const decimalPart = parts.pop();
        number = parts.join('') + '.' + decimalPart;
    } else {
        number = raw;
    }

    const floatVal = parseFloat(number);

    if (isNaN(floatVal)) return 0;

    // Convert to cents
    return Math.round(floatVal * 100);
}

function addStylePriceGroup() {
    return;
    const styleId = 'bss-b2b-temp-style';
    const existingStyle = document.getElementById(styleId);

    if (!existingStyle) {
        const style = document.createElement('style');
        style.id = styleId;
        // style.textContent = `
        //     [bss-b2b-cart-custom], .shop_supplier_and_supplier_checkout, .js-cart-custom-link.additional-requirement_met, .js-cart-custom-link.js_cart_delivery_date_error {
        //         opacity: 0.2 !important;
        //         pointer-events: none !important;
        //     }
        //     [bss-b2b-cart-custom], [bss-b2b-item-original-price], [bss-b2b-final-line-price] {
        //       filter: blur(4px);
        //     }
        //     .shop_supplier_and_supplier_checkout, .js-cart-custom-link.additional-requirement_met, .js-cart-custom-link.js_cart_delivery_date_error {
        //       filter: blur(4px);
        //       color: transparent;
        //     }
        // `;
        style.textContent = `
            [bss-b2b-cart-custom], .shop_supplier_and_supplier_checkout, .js-cart-custom-link.additional-requirement_met, .js-cart-custom-link.js_cart_delivery_date_error {
                opacity: 0 !important;
                pointer-events: none !important;
            }
            [bss-b2b-cart-custom], [bss-b2b-item-original-price], [bss-b2b-final-line-price] {
              opacity: 0 !important;
            }
            .shop_supplier_and_supplier_checkout, .js-cart-custom-link.additional-requirement_met, .js-cart-custom-link.js_cart_delivery_date_error {
              opacity: 0 !important;
            }
        `;
        document.head.appendChild(style);

        setTimeout(() => {
            const styleToRemove = document.getElementById(styleId);
            if (styleToRemove && styleToRemove.parentNode) {
                styleToRemove.parentNode.removeChild(styleToRemove);
            }
        }, 3000);
    }
}

if (isCart) {
  const targetNode = document.querySelector(".cart__summary");

  if (targetNode) {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          BSS_B2B.nt.initFunction();
          document.dispatchEvent(new Event("DOMContentLoaded"));
        }
      }
    });

    const config = {
      childList: true,
      subtree: true,
    };

    observer.observe(targetNode, config);
  }
}

(() => {
  const isCart = ['/cart', '/pages/ws-cart'].includes(window.location.pathname);
  if(isCart) {
    const loop = setInterval(() => {
      const checkoutBtn = document.querySelector("#checkout-button, .btn-cart-checkout");
      const btnNT = document.querySelector("#bss-b2b-net-term-button");
      if(checkoutBtn && btnNT) {
        checkoutBtn.insertAdjacentElement("beforeBegin", btnNT);
        checkoutBtn.remove();
        clearInterval(loop);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(loop);
    }, 3000)
  }
})();


document.addEventListener("bss_b2b:show_thank_you_modal", (e) => { 
  let counter = 0;
let selector = ".b2b-nt-modal-content>div>div>div>p:last-child"
const interval = setInterval(() => {
    let element = document.querySelector(selector);
    if (element) {
        element.remove();
        clearInterval(interval);
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100); 
}, 1);